import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { catchError, from, Subscription } from "rxjs";
// import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { AccountRepositoryService } from "../../pages/account/account-repository.service";
// import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { doc, Firestore, onSnapshot } from "@angular/fire/firestore";
import { IonicModule } from "@ionic/angular";
import { CommonVariable } from "src/app/app.constants";
import { environment } from "src/environments/environment";
import { GTMSagmentService } from "../../services/gtm-sagment.service";

@Component({
  selector: "app-auto-refresh-dialog",
  templateUrl: "./auto-refresh-dialog.component.html",
  styleUrls: ["./auto-refresh-dialog.component.scss"],
  standalone: true,
  imports: [IonicModule, TranslatePipe],
})
export class AutoRefreshDialogComponent implements OnInit {
  selectedId: number = null;
  timer$;
  sub = new Subscription();
  progress: number;
  showSpinner: boolean = false;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  public preferredCurrency: string;
  public currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  credit_refresh_input: Data;
  credit_refresh_output: Data;
  low_trigger_threshold: Data;

  creditDefault = (() => {
    const docRef = doc(this.firestore, `/general_modules/${environment.mirrorPath}system_reference`);
    return onSnapshot(docRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data() as Data;
        this.credit_refresh_input = data?.credit_refresh_input;
        this.credit_refresh_output = data?.credit_refresh_output;
        this.low_trigger_threshold = data?.low_trigger_threshold;
        return data;
      }
    }, (error) => {
      console.error('Error fetching document:', error);
    });
  })();

  constructor(
    private firestore: Firestore,
    private matDialogRef: MatDialogRef<AutoRefreshDialogComponent>,
    private GTMSegment: GTMSagmentService,
    private router: Router,
    private snackService: MySnackBarService,
    private snackBar: MatSnackBar,
    private accountService: AccountRepositoryService,
    public translate: TranslateService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.preferredCurrency = CommonVariable.preferredCurrency;
    this.currencySymbol = CommonVariable.defaultCurrencySymbol;
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.userDetails$.subscribe(
      (user: Data) => {
        this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
        this.authService.getCurrencyList$.subscribe((res: Data) => {
          const CurrencyDetails = res?.details?.find((x: Data) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
        });
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$.subscribe((msg: Data) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    })

    this.GTMSegment.GTMPopupInitialization("DeclineInvitaion");
  }

  ngOnInit() { }

  onReveal(selectedId: number) {
    this.selectedId = selectedId;
  }

  close() {
    this.matDialogRef.close();
  }

  turnOff() {
    let cerditAmount = {
      credit_refresh_input: this?.credit_refresh_input,
      credit_refresh_output: this?.credit_refresh_output,
      low_trigger_threshold: this?.low_trigger_threshold,
    };
    this.matDialogRef.close(true);
    this.authService.creditAutoRefreshOff(cerditAmount).subscribe((res) => {
      if (res?.status === "rejected") {
        this.authService.getConstantsMsg(res?.error_code).then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "Something went wrong!",
              line_2: "",
            },
            style: {
              type: "Error",
              icon: "tick circle error.svg",
            }
          }
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        }).catch((err) => {
          return err;
        });
        return;
      } else {
        from(this.accountService.turnOffCreditRefresh()).pipe(
          catchError((error) => {
            return error;
          })
        ).subscribe(() => {
          this.authService.getConstantsMsg("1059").then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Auto refresh turned off",
                line_2: "You can turn it back on at anytime",
              },
              style: {
                icon: "tick circle success.png",
                type: "Success",
              }
            }
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          });

          return;
        });
      }
    });

  }

  /*
  //spinner
  startSpinner() {
    this.showSpinner = true;
    this.timer$ = interval(20);
    this.sub = this.timer$.subscribe(
      (sec) => {
        if (this.progress == 100) {
          this.sub.unsubscribe();
        }
        this.progress = 0 + sec;
      },
      (err) => {
        return err;
      }
    );
  } */
}
